import { Link } from "react-router-dom";
import { MessageCircleQuestion, Layers, Scale, Compass } from "lucide-react";
import { IMG } from "@/lib/images";

const DOORS = [
  { to: "/dorothee-ia", title: "Demandez à Dorothée IA", d: "Posez une question sur l'ésotérisme, l'histoire ou la médiumnité.", Icon: MessageCircleQuestion, img: IMG.libraryCandle },
  { to: "/dorothee-ia?mode=draw", title: "Une carte pour votre question", d: "Formulez une question, recevez une guidance et une carte tirée pour vous.", Icon: Layers, img: IMG.candle },
  { to: "/vrai-croyance-legende", title: "Vrai, croyance ou légende ?", d: "Devinez, puis découvrez ce que l'on sait vraiment.", Icon: Scale, img: IMG.map },
  { to: "/univers", title: "Découvrir mon univers", d: "Écriture, histoire, rêves, deuil, conférences — explorez sans menu.", Icon: Compass, img: IMG.gothic },
];

export default function DoorsSection() {
  return (
    <section className="dl-container py-16 md:py-20" data-testid="doors-section">
      <div className="text-center mb-10">
        <div className="dl-eyebrow mb-3">Par quelle porte voulez-vous commencer ?</div>
        <h2 className="serif text-3xl md:text-5xl text-[#F3E9D2]">Quatre portes, un même univers</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {DOORS.map(({ to, title, d, Icon, img }, i) => (
          <Link key={to} to={to} data-testid={`door-${i}`}
            className="dl-card group relative overflow-hidden min-h-[240px] flex flex-col justify-end p-7">
            <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1020] via-[#0B1020]/70 to-transparent" />
            <div className="relative z-10">
              <Icon size={24} className="text-[#C6A76A] mb-3" />
              <h3 className="serif text-2xl text-[#F3E9D2] leading-tight group-hover:text-[#D4B978] transition-colors">{title}</h3>
              <p className="text-sm text-[#F3E9D2]/65 mt-2">{d}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
